import { ZENDESK_WIDGET } from '../types/zendesk.js'

export const setZendeskWidget = payload => {
  return {
    type: ZENDESK_WIDGET,
    payload,
  }
}
